import React from 'react'

const SvgCalendarWarningFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 20c0 1.333.667 2 2 2h4.099c.056-.22.137-.439.244-.652l3.218-6.41C13.187 14.813 13 14.5 13 14c.001-.668.335-1.001 1.002-1h.498l.657-1.24A3.145 3.145 0 0118 10H4v10zm6-5H9c-.667.001-1-.332-1-1 .001-.668.335-1.001 1.002-1H10c.667 0 1 .333 1 1s-.333 1-1 1zm0 4H9c-.667.001-1-.332-1-1 .001-.668.335-1.001 1.002-1H10c.667 0 1 .333 1 1s-.333 1-1 1z'
    />
    <path d='M7 4H6c-1.333 0-2 .668-2 2.004V8h16V6c0-1.333-.667-2-2-2h-1V2.941C17 2.314 16.667 2 16 2s-1 .314-1 .941V4H9.004V3c0-.667-.334-1-1.004-1-.67 0-1.002.333-1 1v1z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.131 22.245l4.815-9.588a1.174 1.174 0 012.108 0l4.815 9.588c.402.803-.17 1.755-1.055 1.755h-9.629c-.884 0-1.457-.952-1.054-1.755zm4.605-.599c0-.666.53-1.206 1.184-1.206.654 0 1.184.54 1.184 1.206 0 .666-.53 1.206-1.184 1.206-.654 0-1.184-.54-1.184-1.206zm2.072-6.029c0-.5-.398-.904-.888-.904a.896.896 0 00-.888.904v3.015c0 .5.398.904.888.904s.888-.405.888-.904v-3.015z'
    />
  </svg>
)

export default SvgCalendarWarningFilled
